export default {
    "SubSystemCode": {
        "Code": {
            "ADD": "Thêm mới",
            "EDIT": "Sửa",
            "DELETE": "Xóa",
            "EXPORT": "Xuất khẩu"
        }
    }
};
